var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPpLogoLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ec327fca-b8d9-4aea-b276-29088c5e32d6",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 422.75 43.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M76.9,6A15.11,15.11,0,0,0,61.77,21.1c0,.57,0,1.15.08,1.73a32.3,32.3,0,0,0,2.44,9.06c.49,1.22,1,2.43,1.64,3.62h0a13.64,13.64,0,0,1,21.93,0h0c.58-1.19,1.14-2.4,1.64-3.62a32.52,32.52,0,0,0,2.43-9.06c0-.58.08-1.16.08-1.73A15.11,15.11,0,0,0,76.9,6Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.27,10.71H16.45c6.64,0,11.13,4.87,11.13,11.75S23.09,34.3,16.45,34.3H10.63V44.85H2.27ZM14.73,27.14c2.92,0,4.35-2,4.35-4.68s-1.43-4.59-4.21-4.59H10.63v9.27Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.31,10.71H44.2c3.49,0,5.16.24,6.64.81,3.87,1.48,6.3,5,6.3,9.93,0,3.63-1.72,7.6-5.11,9.32v.09a18.78,18.78,0,0,1,1.29,2.06L60,44.85H50.65l-6.07-11.5H40.67v11.5H32.31Zm12,15.47c2.67,0,4.34-1.48,4.34-4.2,0-1.72-.43-3-2-3.63a7.77,7.77,0,0,0-3.14-.48H40.67v8.31Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.61,10.71h14.18c6.64,0,11.12,4.87,11.12,11.75S117.43,34.3,110.79,34.3H105V44.85H96.61Zm12.46,16.43c2.91,0,4.35-2,4.35-4.68s-1.44-4.59-4.21-4.59H105v9.27Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.64,10.71H148v7.16H135v6.21h10.42v7.16H135v6.45H148.7v7.16H126.64Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8,10.71h11.89c3.48,0,5.15.24,6.64.81,3.86,1.48,6.3,5,6.3,9.93,0,3.63-1.72,7.6-5.11,9.32v.09a21,21,0,0,1,1.29,2.06l6.63,11.93h-9.31l-6.06-11.5h-3.92v11.5H152.8Zm12,15.47c2.67,0,4.34-1.48,4.34-4.2,0-1.72-.42-3-2-3.63a7.82,7.82,0,0,0-3.15-.48h-2.82v8.31Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.62,17.87H182.26V10.71h29.08v7.16H201v27h-8.36Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225,30.86,213.7,10.71h9.51l3.87,8.21c1.09,2.34,2,4.92,2,4.92h.1s1-2.58,2.05-4.92l3.82-8.21h9.5L233.33,30.86v14H225Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.33,10.71h14.19c6.63,0,11.13,4.87,11.13,11.75s-4.5,11.84-11.13,11.84h-5.83V44.85h-8.36ZM261.8,27.14c2.91,0,4.34-2,4.34-4.68s-1.43-4.59-4.2-4.59h-4.25v9.27Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,10.71h21.4v7.16h-13v6.21h10.41v7.16H287.73v6.45h13.71v7.16H279.37Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.3,10.13c10.6,0,17.86,7.65,17.86,17.44,0,10-7.26,17.86-17.86,17.86s-17.86-7.83-17.86-17.86C305.44,17.78,312.69,10.13,323.3,10.13Zm0,27.66c5.4,0,9.22-4.4,9.22-10.22,0-5.59-3.82-9.79-9.22-9.79s-9.22,4.2-9.22,9.79C314.08,33.39,317.9,37.79,323.3,37.79Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.88,10.71h14.19c6.64,0,11.13,4.87,11.13,11.75S366.71,34.3,360.07,34.3h-5.82V44.85h-8.37Zm12.47,16.43c2.92,0,4.35-2,4.35-4.68s-1.43-4.59-4.21-4.59h-4.24v9.27Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.93,10.71h8.36v27h13.94v7.16h-22.3Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403,10.71h21.39v7.16h-13v6.21h10.41v7.16H411.31v6.45H425v7.16H403Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9,15.62a6.15,6.15,0,1,0,4.34,1.8A6.12,6.12,0,0,0,76.9,15.62Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.86,35.51a13.64,13.64,0,0,0-21.93,0,0,0,0,0,0,0,0,88.87,88.87,0,0,0,7.48,12.24h0a4.28,4.28,0,0,0,7,0h0a89.89,89.89,0,0,0,7.47-12.24Z",
    transform: "translate(-2.27 -6)",
    style: {
      fill: "#b4e1fa"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpLogoLight);
export default __webpack_public_path__ + "static/media/pp-logo-light.43b1ab8c.svg";
export { ForwardRef as ReactComponent };